import useLocalStorageState from './useLocalStorageState';

export default useLocalStorageState;
